/**
 * Where the Tesla connection lives.
 *
 * In its own module because the OAuth callback navigates here and the route
 * table, the sidebar and the import page's error all point at it. A string
 * repeated in four places is a string that goes stale in three of them, and
 * the sidebar test that walks every menu path against the router would catch
 * only one of those.
 */
export const TESLA_CONNECTION_PATH = '/admin/account/tesla'
